import React from "react";
import { Navigate, useParams } from "react-router-dom";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  PageHero,
  ProcessSection,
  RelatedLinksSection,
  ServiceDetailSection,
} from "../components/JalRoSections";
import { useServices } from "../hooks/useSiteData";

const ServiceDetailsPage = () => {
  const { slug } = useParams();
  const { items: serviceDetails, loaded } = useServices();
  const service = serviceDetails.find((item) => item.slug === slug);

  if (!service && !loaded) {
    return <JalRoLayout><PageHero title="Loading Service" text="Please wait while service details load." /></JalRoLayout>;
  }

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return (
    <JalRoLayout>
      <PageHero title={service.title} text={service.summary} image={service.image} />
      <ServiceDetailSection service={service} />
      <ProcessSection />
      <RelatedLinksSection currentSlug={service.slug} />
      <ContactCtaSection />
    </JalRoLayout>
  );
};

export default ServiceDetailsPage;
